// クラシック版の右の列の編集のボタンの定義（段階 C の2 の 5c-2。2026-10-25 に chibi.js と画面ファイル gen1.js・gen2.js・gen1b.js・legacy.js から描き直した。動きは前と同じ）。
// メニュー・色・柄・復元・パーツの一覧の開け閉め・調整・左右。系統（SCREEN）ごとの違い:
//   色: エンジンのまま（柄の欄と排他・使えないカテゴリは押せない）／第1世代（調整と排他・いつも押せる）／第2世代（調整・柄と排他。押せるかの判定は前のまま関数そのもの＝いつも押せる）
//   柄: エンジンのまま（第1世代も）／第2世代（調整も閉じる）
//   パーツの一覧: エンジンのまま（PC は下から開く）／第1世代 a・第2世代（前の legacy.js。スマホも PC も上の位置から）／第1世代 b（右の列のボタン。カテゴリとパーツの一覧を一緒に出し入れ）
//   調整: エンジンのまま（移動の入り切りだけ）／第1世代（サブのボタンを出し入れ、色と排他）／第2世代（色・柄と排他）
//   左右: エンジンのまま（絵 lrselect_*）／第1世代（絵 lr_*、ENABLED で選択の状態を合わせる）／第2世代（それと吹き出し）
// mono の色は画面ファイル gen1-pattern.js が自前のもの（main.ts は上書きしない）。
// 他のボタンを閉じる・合わせるときは、そのボタンの押す所の d3 のクリックを取り出して呼ぶ（前と同じ。makeMenuButton の押す所）
import { chibi, common } from './engine.js';
import { screen } from './colors.js';
import * as fx from './fx.js';

type Engine = Record<string, any>;
const E = (): Engine => chibi() as unknown as Engine;
const C = (): Record<string, any> => common() as unknown as Record<string, any>;
const button = (): { setMask(sel: unknown, valid: boolean): void } => (window as unknown as { charat: { button: { setMask(sel: unknown, valid: boolean): void } } }).charat.button;
const tt = (): Record<string, string> => (typeof _t !== 'undefined' && _t ? _t : {});
/** ほかのメニューのボタンを押したことにする（そのボタンの押す所の d3 のクリックを、ボタンの定義を渡して呼ぶ） */
const press = (target: string, btn: string = target): void => fx.d3ClickCall('#' + E()[target].ID + 'click', { BTN: E()[btn] });
const mask = (name: string): void => button().setMask(E().svgMakeMenu.select('#' + E()[name].ID + '>image'), E()[name].VALID());
const show = (sel: string, display: string, opacity: number): void => {
  fx.setCss(sel, 'display', display);
  fx.setCss(sel, 'opacity', opacity);
};
/** jQuery の css("opacity") を前と同じく数と == で比べる（文字のまま。"0" == 0 は真） */
const opacityOf = (sel: string): unknown => fx.getCss(sel, 'opacity');
const hide = (sel: string): void => {
  fx.setCss(sel, 'opacity', 0);
  fx.setCss(sel, 'display', 'none');
};

/** ボタンの定義を作る（読み込みの時点の設定で絵を決める。前と同じ） */
export function makeEditButtons(): Record<string, unknown> {
  const e = E();
  const P = e.PATH_IMG, KEY = e.SVG_FILE_KEY, MENU = e.ATTR_EDITMENUBUTTON;
  const scr = screen(), gen1 = scr === 'gen1a' || scr === 'gen1b', gen2 = scr === 'gen2';
  const SW = C().makeMenuButtonModeSW, SEL = C().makeMenuButtonModeSel;
  const btns: Record<string, any> = {};

  // メニュー（メニューの一覧をフェードで出し入れ）
  btns.btnEditMenu = {
    ID: MENU + 'Menu',
    STATUS: 0,
    FILE: [P + 'ico_right/menu.svg'],
    CLICK: () => {
      if (E().btnEditMenu.STATUS == 1) fx.fadeIn(E().DIV_F_EDITMENU, 200);
      else E().btnEditMenu.OFF(200);
    },
    OFF: (aDur?: number, aCallback?: () => void) => {
      fx.fadeOut(E().DIV_F_EDITMENU, aDur == undefined ? 0 : aDur, () => {
        if (aCallback != undefined) aCallback();
      });
    },
  };

  // 色（色の列の出し入れ）
  if (gen1) {
    btns.btnEditColor = {
      ID: MENU + 'Color',
      STATUS: 0,
      FILE: [P + 'ico_right/color.svg'],
      CLICK: () => {
        const b = E().btnEditColor;
        if (b.STATUS == 0) b.OFF();
        else {
          b.ON();
          if (b.STATUS == 1 && E().btnEditSub.STATUS == 1) press('btnEditSub');
        }
      },
      ON: () => {
        if (E().btnEditColor.STATUS == 1) show(E().DIV_F_COLORAREA, 'inline', 1);
      },
      OFF: () => {
        if (E().btnEditColor.STATUS == 0) hide(E().DIV_F_COLORAREA);
      },
    };
  } else {
    btns.btnEditColor = {
      ID: MENU + 'Color',
      MODE: SW,
      STATUS: 0,
      _VALID: false,
      VALID: () => E().btnEditColor._VALID,
      FILE: [P + 'ico_right/color.svg' + KEY],
      CLICK: () => {
        const b = E().btnEditColor;
        // 第2世代は VALID を () なしで見ている（関数そのものなのでいつも真。前のまま）
        if (gen2 ? !!b.VALID : b.VALID()) {
          if (b.STATUS == 0) b.OFF();
          else {
            b.ON();
            if (gen2 && b.STATUS == 1 && E().btnEditSub.STATUS == 1) press('btnEditSub');
            if (b.STATUS == 1 && E().btnEditPattern.STATUS == 1) press('btnEditPattern');
          }
        }
      },
      ON: () => {
        if (E().btnEditColor.STATUS == 1) {
          E().btnEditPattern.OFF();
          show(E().DIV_F_COLORAREA, 'inline', 1);
        }
      },
      OFF: () => {
        if (E().btnEditColor.STATUS == 0) hide(E().DIV_F_COLORAREA);
      },
      // 押せるかを切りかえ、色の列を開いた・閉じた形にそろえる（今と違えばボタンを押したことにする）
      ENABLED: (aValid: boolean, anOpen?: boolean) => {
        const b = E().btnEditColor;
        if (b.STATUS == 0) {
          if (anOpen == true) press('btnEditColor');
        } else if (anOpen != true) {
          // 注意: エンジンのままは調べる用の console.log が残っている（前のまま）
          if (!gen2) console.log(b.STATUS);
          press('btnEditColor');
        }
        b._VALID = aValid;
        mask('btnEditColor');
      },
    };
  }

  // 柄（柄の欄の出し入れ。色と排他。注意: VALID を () なしで見ているので、柄が使えないカテゴリでも押せる＝前のまま）
  btns.btnEditPattern = {
    ID: MENU + 'Pattern',
    MODE: SW,
    STATUS: 0,
    _VALID: false,
    VALID: () => E().btnEditPattern._VALID,
    FILE: [P + 'ico_right/pattern.svg' + KEY],
    CLICK: () => {
      const b = E().btnEditPattern;
      if (b.VALID) {
        if (b.STATUS == 0) b.OFF();
        else {
          b.ON();
          if (gen2 && b.STATUS == 1 && E().btnEditSub.STATUS == 1) press('btnEditSub');
          if (b.STATUS == 1 && E().btnEditColor.STATUS == 1) press('btnEditColor');
        }
      }
    },
    ON: () => {
      if (E().btnEditPattern.STATUS == 1) {
        E().btnEditColor.OFF();
        show(E().DIV_F_PATTERNAREA, 'inline', 1);
      }
    },
    OFF: () => {
      if (E().btnEditPattern.STATUS == 0) hide(E().DIV_F_PATTERNAREA);
    },
    // 押せるかを切りかえ、柄の欄を開いた・閉じた形にそろえる（使えないときは開いていれば閉じる）。使えるカテゴリでは吹き出し
    ENABLED: (aValid: boolean, anOpen?: boolean) => {
      const b = E().btnEditPattern;
      if (b.STATUS == 0) {
        if (anOpen == true) press('btnEditPattern');
      } else if (aValid == false || anOpen != true) {
        press('btnEditPattern');
      }
      b._VALID = aValid;
      mask('btnEditPattern');
      if (aValid) {
        fx.tooltip('PATTERN', true, '#' + MENU + 'Pattern > image', 'left', tt().pattern_tip ? tt().pattern_tip : 'Some categories allow you to add patterns.');
      }
    },
  };

  // 復元（復元の欄をフェードで出し入れ）
  btns.btnRestore = {
    ID: MENU + 'Restore',
    MODE: SW,
    STATUS: 0,
    FILE: [P + 'ico_right/restore.svg' + KEY],
    CLICK: () => {
      if (E().btnRestore.STATUS == 1) fx.fadeIn(E().DIV_F_RESTORE, 200);
      else E().btnRestore.OFF(200);
    },
    OFF: (aDuration?: number, aCallback?: () => void) => {
      fx.fadeOut(E().DIV_F_RESTORE, aDuration == undefined ? 0 : aDuration, () => {
        if (aCallback != undefined) aCallback();
      });
    },
  };

  // パーツの一覧の開け閉め
  if (scr === 'gen1b') {
    // 第1世代 b: 右の列のボタン。カテゴリとパーツの一覧を一緒に（動きなしで）出し入れ
    btns.btnEditParts = {
      ID: MENU + 'Parts',
      STATUS: 0,
      FILE: [P + 'ico_right/closet.svg'],
      CLICK: () => {
        if (E().btnEditParts.STATUS == 0) E().btnEditParts.OFF();
        else E().btnEditParts.ON();
      },
      ON: () => {
        const en = E();
        fx.setCss(en.DIV_F_CATEGORY_SC, 'opacity', 0.9);
        fx.setCss(en.DIV_F_PARTS_SC, 'opacity', 1);
        fx.setCss(en.DIV_F_CATEGORY_SC, 'display', 'block');
        fx.setCss(en.DIV_F_PARTS_SC, 'display', 'block');
      },
      OFF: () => {
        const en = E();
        fx.setCss(en.DIV_F_CATEGORY_SC, 'opacity', 0);
        fx.setCss(en.DIV_F_PARTS_SC, 'opacity', 0);
        fx.setCss(en.DIV_F_CATEGORY_SC, 'display', 'none');
        fx.setCss(en.DIV_F_PARTS_SC, 'display', 'none');
      },
    };
  } else {
    // エンジンのまま（PC は下の位置から）・第1世代 a と第2世代（前の legacy.js。スマホも PC も上の位置から）。ORGSIZE は初めて出したときのパーツの欄の高さ
    const fromTop = scr !== 'new';
    btns.btnEditParts = {
      ORGSIZE: -1,
      // パーツの欄を出す（oncheck が true で出ていれば何もしない）。初めはそのまま、2 回目からは元の高さまで伸ばす
      ON_PARTS: (oncheck?: boolean) => {
        const en = E(), sbar = en.DIV_F_PARTS_SC, catbar = en.DIV_F_CATEGORY_SC;
        if (oncheck == true && opacityOf(sbar) != 0) return;
        let init = false;
        if (en.btnEditParts.ORGSIZE == -1) {
          en.btnEditParts.ORGSIZE = fx.height(sbar);
          init = true;
        }
        if (fromTop || en.isMobile) fx.setCss(sbar, 'top', fx.height(en.DIV_F_MAIN) - fx.height(sbar));
        else fx.setCss(sbar, 'bottom', 0);
        fx.setCss(catbar, 'opacity', 0.9);
        fx.setCss(catbar, 'display', 'block');
        if (init) {
          fx.setCss(sbar, 'opacity', 0.9);
          fx.setCss(sbar, 'display', 'block');
        } else {
          // 注意: エンジンのままも PC で top を動かしている（スマホと同じ式。前のまま）
          fx.setCss(sbar, 'display', 'block');
          fx.setCss(sbar, 'opacity', 0.9);
          fx.animate(sbar, { height: en.btnEditParts.ORGSIZE + 'px', top: fx.height(en.DIV_F_MAIN) - en.btnEditParts.ORGSIZE + 'px' }, 200, 'easeInOutBack', () => {});
        }
      },
      // パーツの欄をたたんで隠す（カテゴリの欄は出したまま）
      OFF_PARTS: () => {
        const en = E(), sbar = en.DIV_F_PARTS_SC, catbar = en.DIV_F_CATEGORY_SC;
        fx.setCss(catbar, 'opacity', 0.9);
        fx.setCss(catbar, 'display', 'block');
        const props: Record<string, string> = fromTop || en.isMobile ? { height: '0px', top: fx.height(en.DIV_F_MAIN) + 'px' } : { height: '0px', bottom: '0px' };
        fx.animate(sbar, props, 200, 'easeInOutBack', () => {
          fx.setCss(sbar, 'display', 'none');
          fx.setCss(sbar, 'opacity', 0);
        });
      },
      // 出し入れを切りかえる（同じカテゴリをもう一度押したとき）
      SW_PARTS: () => {
        if (opacityOf(E().DIV_F_PARTS_SC) == 0) E().btnEditParts.ON_PARTS();
        else E().btnEditParts.OFF_PARTS();
      },
    };
  }

  // 調整
  btns.btnEditSub = {
    ID: MENU + 'Sub',
    STATUS: 0,
    FILE: [P + 'ico_right/adjust.svg'],
    CLICK: () => {
      const en = E(), b = en.btnEditSub;
      if (scr === 'new') {
        // エンジンのまま: 選んでいるカテゴリが動かせるなら移動を入り切り（このボタンはどのメニューにも置いていない）
        if (en.selCategory.IS_MOVE != 0) {
          if (b.STATUS == 1) en.btnSubMove.ON();
          else en.btnSubMove.OFF();
        }
        return;
      }
      // 系統のある画面: サブのボタンを出し入れし、色（第2世代は柄も）が開いていれば閉じる
      const vis = b.STATUS == 0 ? 'hidden' : 'visible';
      if (b.STATUS == 0) en.btnSubMove.OFF();
      document.querySelectorAll('g.' + en.ATTR_EDITSUBBUTTON).forEach((g) => g.setAttribute('visibility', vis));
      if (b.STATUS == 1 && en.btnEditColor.STATUS == 1) press('btnEditColor');
      else if (gen2 && b.STATUS == 1 && en.btnEditPattern.STATUS == 1) press('btnEditPattern');
    },
  };

  // 左右（選択型。押すたびに 両方 → 左 → 右）
  btns.btnEditLR = {
    ID: MENU + 'LeftRight',
    MODE: SEL,
    STATUS_INIT: false,
    STATUS: 0,
    STATUS_MAX: 3,
    FILE: scr === 'new' ? [P + 'ico_right/lrselect_1.svg', P + 'ico_right/lrselect_2.svg', P + 'ico_right/lrselect_3.svg'] : [P + 'ico_right/lr_lr.svg', P + 'ico_right/lr_l.svg', P + 'ico_right/lr_r.svg'],
    VALID: () => E().btnEditLR.STATUS != 0,
    CLICK: () => {
      const b = E().btnEditLR;
      if (b.STATUS_INIT == false) {
        mask('btnEditLR');
        b.STATUS_INIT = true;
      } else {
        if (++b.STATUS > b.STATUS_MAX) b.STATUS = 1;
        E().btnSubSelect.SETSTATUS(b.STATUS - 1);
      }
    },
    RESET: () => {},
    ENABLED: (valid: boolean) => {
      const b = E().btnEditLR;
      b.STATUS = valid ? 1 : 0;
      E().btnSubSelect.SETSTATUS(0);
      b.STATUS_INIT = false;
      if (scr === 'new') return;
      // 系統のある画面: 調整のボタンの押す所を、左右のボタンの定義を渡して呼ぶ（左右のボタンの絵と位置がそろう。前と同じ）
      press('btnEditSub', 'btnEditLR');
      if (gen2 && valid) {
        fx.tooltip('LEFTRIGHT', true, '#' + MENU + 'LeftRight > image', 'left', tt().lr_tip ? tt().lr_tip : 'In some categories, you can choose different colors for left and right.');
      }
    },
  };
  // エンジンのままだけにある値（使っていない）
  if (scr === 'new') btns.btnEditLR.FIRST_CLICK = true;
  return btns;
}
